import React from "react";
import { Metric } from "../types";
import listSvg from "../../assets/events/list.svg";
import assistsSvg from "../../assets/events/assists.svg";
import crossesSvg from "../../assets/events/crosses.svg";
import foulsSvg from "../../assets/events/fouls.svg";
import goalsSvg from "../../assets/events/goals.svg";
import keyPassesSvg from "../../assets/events/key-passes.svg";
import passAccuracySvg from "../../assets/events/pass-accuracy.svg";
import passesSvg from "../../assets/events/passes.svg";
import redSvg from "../../assets/events/red-yellow-card.svg";
import yellowSvg from "../../assets/events/red-yellow-card.svg";
import shotsSvg from "../../assets/events/shots.svg";
import tacklesSvg from "../../assets/events/tackles.svg";
import xgSvg from "../../assets/events/xg.svg";
import savesSvg from "../../assets/events/saves.svg";

const ImgIcon: React.FC<{
  src: string;
  alt: string;
  size?: number | string;
}> = ({ src, alt, size = 48 }) => {
  const dimension = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src={src}
      alt={alt}
      style={{
        display: "block",
        width: dimension,
        height: dimension,
      }}
    />
  );
};

export const makeMetricIcons = ({
  size = 24,
}: { size?: number | string } = {}) => {
  const map: Record<Metric, React.ReactElement> = {
    list: <ImgIcon src={listSvg} alt="list" size={size} />,
    assists: <ImgIcon src={assistsSvg} alt="assists" size={size} />,
    crosses: <ImgIcon src={crossesSvg} alt="crosses" size={size} />,
    fouls: <ImgIcon src={foulsSvg} alt="fouls" size={size} />,
    goals: <ImgIcon src={goalsSvg} alt="goals" size={size} />,
    keyPasses: <ImgIcon src={keyPassesSvg} alt="key passes" size={size} />,
    passAccuracy: (
      <ImgIcon src={passAccuracySvg} alt="pass accuracy" size={size} />
    ),
    passes: <ImgIcon src={passesSvg} alt="passes" size={size} />,
    red: <ImgIcon src={redSvg} alt="red card" size={size} />,
    yellow: <ImgIcon src={yellowSvg} alt="yellow card" size={size} />,
    shots: <ImgIcon src={shotsSvg} alt="shots" size={size} />,
    tackles: <ImgIcon src={tacklesSvg} alt="tackles" size={size} />,
    xg: <ImgIcon src={xgSvg} alt="xG" size={size} />,
    saves: <ImgIcon src={savesSvg} alt="saves" size={size} />,
  };
  return map;
};

export type MetricIconName = Metric;
